import { render, staticRenderFns } from "./gradingReward.vue?vue&type=template&id=3273c5d0&scoped=true&"
import script from "./gradingReward.vue?vue&type=script&lang=js&"
export * from "./gradingReward.vue?vue&type=script&lang=js&"
import style0 from "./gradingReward.vue?vue&type=style&index=0&id=3273c5d0&lang=scss&scoped=true&"
import style1 from "./gradingReward.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./gradingReward.vue?vue&type=style&index=2&id=3273c5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3273c5d0",
  null
  
)

export default component.exports